import { useAuth } from "~/stores/auth.js";

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();
  const auth = useAuth();

  const api = $fetch.create({
    baseURL: runtimeConfig.public.apiUrl + "/api/v1/customer",
    onRequest({ options }) {
      if (!options.headers.has("Accept")) {
        options.headers.set("Accept", "application/json");
      }

      options.headers.set("Authorization", `Bearer ${auth.token}`);

      options.headers.set("Domain", document.location.origin);
    },
  });

  // Expose to useNuxtApp().$api
  return {
    provide: {
      api,
    },
  };
});
